<template>
    <div v-if="!isAccepted" class="wide-cookies-consent pa-3">
        Il sito utilizza i cookies, l'utente navigando nel sito web dichiara di acconsentire all’utilizzo dei cookies. <a href="http://www.battisti.it/cookies.aspx" target="_blank">Informazioni</a> <v-btn class="ma-0 ml-3" flat color="primary" @click="acceptCookies">Accetta</v-btn>
    </div>
</template>

<script>
export default {
    name: 'cookie',
    data: () => ({
        isAccepted: false,
    }),
    methods: {
       checkAccepted() {
           if (this.$cookies.isKey('consent')) {
               if (this.$cookies.get('consent')=='1') {
                   this.isAccepted = true;
               } else {
                   this.$cookies.remove('consent')
               }
           }
       },
       acceptCookies() {
           this.$cookies.set('consent', '1', 30);
           this.checkAccepted();
       }
    },
    created() {
        this.checkAccepted();
    }
}
</script>

<style lang="stylus" scoped>

.wide-cookies-consent
    z-index: 15
    position: fixed
    bottom: 0
    left: 0
    width: 100%
    background-color: #FFF

</style>
